import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple"> Bhavin, </span>
            an MCA graduate and <span className="purple"> Experienced Full-Stack Software Developer </span>

            with a passion for creating robust and user-friendly web applications. As a full-stack engineer, I am adept at <span className="purple"> both front-end and back-end development, </span>ensuring seamless integration and functionality. I excel in translating complex business needs into efficient technical solutions, leveraging my expertise to deliver impactful software solutions.



            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Cricket
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          {/* <p style={{ color: "rgb(155 126 172)" }}>
            "testing"{" "}
          </p>
          <footer className="blockquote-footer">Bhavin</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
